export default __webpack_public_path__ + "static/media/img-cleanser.4e6b9606.svg";